
import { User } from "@/models/user";
import Vue from "vue";
import { CompanyUserService } from "@/services/company-user-service";
import AppUserEdit from "../UserEdit.vue";
import AppAccountantDossiers from "../AccountantDossiers.vue";
export default Vue.extend({
	data() {
		return {
			user: new User(),
			password: "",
			currentTab: 0
		};
	},
	props: {
		value: {
			type: Object as () => User,
			required: true
		},
	},
	computed: {
		title():string {
			if (this.value.id == 0) {
				return "Create user";
			}
			return "Edit user";
		},
		tabs():string[] {
			let result = ["Gebruiker"];
			if (this.user.id && this.user.isAccountant) {
				result.push("Boekhouder dossiers");
			}
			return result;
		}
	},
	watch: {
		value: {
			immediate: true,
			handler(val:User) {
				this.user = val;
				this.currentTab = 0;
			}
		}
	},
	methods: {
		cancel() {
			this.$emit("close");
		},
		async save() {
			if (this.user.id != 0) {
				var user = await CompanyUserService.updateUser(this.value.companyId, this.user);
				if (!this.password.match(/^\s*$/)) {
					await CompanyUserService.updatePassword(this.user.companyId, this.user, this.password);
				}
			} else {
				var user = await CompanyUserService.createNewUser(this.value.companyId, this.user, this.password);
			}
			this.$emit("input", user);
			this.$emit("close");
		},
	},
	components: {
		AppUserEdit,
		AppAccountantDossiers
	}
});
